import React from "react";
import axios from "axios";
import { connect } from "react-redux";
import * as actions from "../../store/actions";

import Button from "../../components/CustomButtons/Button";
import SpecialButton from "../../components/CustomInput/SpecialButton";
import SaveButton from "../../components/CustomInput/SaveButton";

import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import CardHeader from "../../components/Card/CardHeader";
import CardIcon from "../../components/Card/CardIcon";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "../../components/Grid/GridItem";
import MainNavbar from "../../components/Navbars/MainNavbar";
import VestigingenFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";
import { withStyles } from "tss-react/mui";
import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import { Alert, Checkbox, Collapse, FormControl, FormLabel, Select } from "@mui/material";
import { Filter1, Filter2, Filter3, GetApp, Translate } from "@mui/icons-material";

import { convertObjectToSelectOptions } from "../../templateHelpers";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { toast } from "react-toastify";
import { talenV5 } from "../../variables/app";

class Index extends React.Component {
  form = React.createRef();

  state = {
    //show toggles
    showTransedit: false,
    //busy flags
    saving: false,
    prepareTranseditBusy: false,
    saveTranseditBusy: false,
    cancelTranseditBusy: false,
    deleteAllBusy: false,
    exportExcelBusy: false,
    importExcelBusy: false,
    //checkboxes
    menuItemsChecked: true,
    productsChecked: true,
    descriptionsChecked: true,
    optionsChecked: true,
    upsellSettings: true,
    productUpsellSettings: true,
    allowDeleteChecked: false,
    //excel export
    excelExport: {
      buttonInitialized: true,
      downloadAvailable: null,
      downloadLink: null,
      count: null,
      saving: false,
    },
    //excel import
    hasUploadFilename: false,

    //selectedFile: null, // Initially, no file is selected

    //misc & custom
    sessionGarble: "INIT",
    extraAreas: [], // for near future extension
    transLang: null,
  };

  jamezzTable = React.createRef();

  //##############################################################################
  // function startTransEdit
  startTransedit = (extraSignal) => {
    this.setState({ prepareTranseditBusy: true });
    let data = {
      filters: this.props.filters,
      extraSignal: extraSignal,
      salesarea_ids: this.props.vestiging_id,
      transLang: this.state.transLang,
      menuItemsChecked: this.state.menuItemsChecked,
      productsChecked: this.state.productsChecked,
      descriptionsChecked: this.state.descriptionsChecked,
      optionsChecked: this.state.optionsChecked,
      upsellSettingsChecked: this.state.upsellSettings,
      productUpsellSettingsChecked: this.state.productUpsellSettings,
    };
    console.log(this.props.vestiging_id);
    axios
      .post("/core/transedit/prepareTransedit", data)
      .then((response) => {
        if (response.data.data.success) {
          if (response.data.data.warning) {
            toast.warn(response.data.data.message);
          } else {
            toast.success(response.data.data.message);
          }
          this.setState({ sessionGarble: response.data.data.sessionGarble });
          this.setState({ prepareTranseditBusy: false });
          this.setState({ showTransedit: true });
          this.props.setFilter("sessionGarble", {
            field: "sessionGarble",
            operator: "=",
            value: response.data.data.sessionGarble,
          });

          this.jamezzTable.current?.refreshData();
        } else {
          this.setState({ showTransedit: false });
          toast.error(response.data.data.message);
        }
      })
      .catch((error) => {
        console.error("Receiving POST Error: [" + error + "]");
      });
    return true;
  };

  //##############################################################################
  // function saveTransEdit
  saveTransedit = (extraSignal) => {
    this.setState({ saveTranseditBusy: true });
    let data = {
      filters: this.props.filters,
      extraSignal: extraSignal,
      salesarea_ids: this.props.vestiging_id,
      transLang: this.state.transLang,
      sessionGarble: this.state.sessionGarble,
    };

    axios
      .post("/core/transedit/saveTransedit", data)
      .then((response) => {
        if (response.data.data.success) {
          toast.success(response.data.data.message);
          this.setState({ saveTranseditBusy: false });
          this.setState({ hasUploadFilename: false });
          this.setState({ showTransedit: false });
          this.jamezzTable.current?.refreshData();
        } else {
          toast.error(response.data.data.message);
        }
      })
      .catch((error) => {
        console.error("Receiving POST Error: [" + error + "]");
      });
    return true;
  };

  //##############################################################################
  // function cancelTransEdit
  cancelTransedit = () => {
    this.setState({ showTransedit: false });
    this.setState({ hasUploadFilename: false });
    return true;
  };

  //##############################################################################
  // function deleteAllTranslations
  deleteAllTranslations = () => {
    this.setState({ deleteAllBusy: true });
    let data = {
      filters: this.props.filters,
      salesarea_ids: this.props.vestiging_id,
    };

    axios
      .post("/core/transedit/deleteAllTranslations", data)
      .then((response) => {
        if (response.data.data.success) {
          toast.success(response.data.data.message);
          this.setState({ deleteAllBusy: false });
          this.jamezzTable.current?.refreshData();
        } else {
          toast.error(response.data.data.message);
        }
      })
      .catch((error) => {
        console.error("Receiving POST Error: [" + error + "]");
      });
    return true;
  };

  //###############################################
  //functions to handle prepartion excel download
  excelExport_handlePrepareDownload = () => {
    this.setState({ exportExcelBusy: true });
    let data = {
      filters: this.props.filters,
      extraAreas: this.state.extraAreas,
      transLang: this.state.transLang,
      menuItemsChecked: this.state.menuItemsChecked,
      productsChecked: this.state.productsChecked,
      descriptionsChecked: this.state.descriptionsChecked,
      optionsChecked: this.state.optionsChecked,
      upsellSettingsChecked: this.state.upsellSettings,
      productUpsellSettingsChecked: this.state.productUpsellSettings,
    };

    axios
      .post("/core/transedit/" + this.props.vestiging_id + "/excelExportTranslations", data)
      .then((response) => {
        if (response.data.data.success) {
          toast.success(response.data.data.message);
          this.setState({ exportExcelBusy: false });
          //update state excelExport
          let linkDataFile = response.data.data.filename;
          let newExcelExport = this.state.excelExport;
          newExcelExport["downloadAvailable"] = true;
          newExcelExport["downloadLink"] = linkDataFile;
          this.setState({ excelExport: newExcelExport });
        } else {
          toast.error(response.data.data.message);
        }
      })
      .catch((error) => {
        console.error("Receiving POST Error: [" + error + "]");
      });
    return true;
  };

  //###############################################
  //function to handle excel import (import)
  excelImport = (e) => {
    e.preventDefault(); //prevent submit default
    this.setState({ importExcelBusy: true });
    let data = new FormData(this.form.current);
    data.append("filters", this.props.filters);
    data.append("extraAreas", this.state.extraAreas);
    data.append("transLang", this.state.transLang);

    axios
      .post("/core/transedit/" + this.props.vestiging_id + "/excelImportTranslations", data)
      .then((response) => {
        if (response.data.data.success) {
          toast.success(response.data.data.message);
          this.setState({ importExcelBusy: false });

          // //update state excelExport
          // let linkDataFile = response.data.data.filename;
          // let newExcelExport = this.state.excelExport;
          // newExcelExport["downloadAvailable"] = true;
          // newExcelExport["downloadLink"] = linkDataFile;
          // this.setState({ excelExport: newExcelExport });
        } else {
          toast.error(response.data.data.message);
        }
      })
      .catch((error) => {
        console.error("Receiving POST Error: [" + error + "]");
      });
    return true;
  };

  //###############################################
  //functions to handle checkbox "MenuItems"
  handleCheckboxMenuItems = (event) => {
    let newState = { ...this.state };
    newState.menuItemsChecked = event.target.checked;
    this.setState(newState);
  };
  isCheckedMenuItems = () => {
    return this.state.menuItemsChecked;
  };

  //###############################################
  //functions to handle checkbox "Products"
  handleCheckboxProducts = (event) => {
    let newState = { ...this.state };
    newState.productsChecked = event.target.checked;
    this.setState(newState);
  };
  isCheckedProducts = () => {
    return this.state.productsChecked;
  };

  //###############################################
  //functions to handle checkbox "Descriptions"
  handleCheckboxDescriptions = (event) => {
    let newState = { ...this.state };
    newState.descriptionsChecked = event.target.checked;
    this.setState(newState);
  };
  isCheckedDescriptions = () => {
    return this.state.descriptionsChecked;
  };

  allowImportExport = () => {
    return !this.props.vestiging_id || this.props.vestiging_id.length > 1;
  };

  //###############################################
  //functions to handle checkbox "Options"
  handleCheckboxOptions = (event) => {
    let newState = { ...this.state };
    newState.optionsChecked = event.target.checked;
    this.setState(newState);
  };

  handleCheckboxUpsellSettings = (event) => {
    let newState = { ...this.state };
    newState.upsellSettings = event.target.checked;
    this.setState(newState);
  };
  handleProductCheckboxUpsellSettings = (event) => {
    let newState = { ...this.state };
    newState.productUpsellSettings = event.target.checked;
    this.setState(newState);
  };
  isCheckedOptions = () => {
    return this.state.optionsChecked;
  };

  //###############################################
  //functions to handle checkbox "Allow Delete All"
  handleCheckboxAllowDelete = (event) => {
    let newState = { ...this.state };
    newState.allowDeleteChecked = event.target.checked;
    this.setState(newState);
  };
  isCheckedAllowDelete = () => {
    return this.state.allowDeleteChecked;
  };

  //###############################################
  //functions to handle selection upload file
  handleFileUploadChange = (event) => {
    this.setState({
      hasUploadFilename: event.target.files[0] ? true : false,
    });
  };

  //##############################################################################
  render() {
    const { classes } = this.props;
    const showTransLangItems = [
      {
        value: "en",
        label: getTranslation("transedit.form.transLang.EN", "EN  -  English"),
      },
      {
        value: "nl",
        label: getTranslation("transedit.form.transLang.NL", "NL  -  Dutch"),
      },
    ];
    const showTransLangOptions = convertObjectToSelectOptions(talenV5, classes);

    // construct button_excelExport
    let button_excelExport = "";
    if (this.state.excelExport.buttonInitialized === null) {
      button_excelExport = <span>..initializing..</span>;
    } else {
      if (this.state.excelExport.downloadAvailable === null) {
        button_excelExport = (
          <>
            <Collapse in={this.props.vestiging_id ? this.props.vestiging_id.length > 1 : null}>
              <Alert severity={"warning"} style={{ width: "100%" }}>
                <TranslationWrapper
                  tDefault={"You can only export & import a single salesarea, adjust your filters."}
                  tKey={"transedit.export.only_support_single_salesarea"}
                />
              </Alert>
            </Collapse>
            <Collapse in={!this.props.vestiging_id}>
              <Alert severity={"warning"} style={{ width: "100%" }}>
                <TranslationWrapper
                  tDefault={"You need to select a salesarea, adjust your filters."}
                  tKey={"transedit.export.atleast_one_salesarea"}
                />
              </Alert>
            </Collapse>
            <SpecialButton
              busyFlag={this.state.exportExcelBusy}
              buttonColor={"success"}
              buttonText={
                <TranslationWrapper
                  tDefault={"Export (Genereer download file)"}
                  tKey={"transedit" + "." + "form.button.excelImportGenerateDownload"}
                />
              }
              buttonTextDisabled={
                <TranslationWrapper
                  tDefault={"Preparing download file. Please Wait.."}
                  tKey={"transedit" + "." + "form.button.prepareDownloadFile"}
                />
              }
              disabled={this.allowImportExport() || this.state.transLang == null}
              onClick={() => this.excelExport_handlePrepareDownload()}
            />
          </>
        );
      } else {
        button_excelExport = (
          <Button download={this.state.excelExport.downloadLink} href={this.state.excelExport.downloadLink}>
            <GetApp />{" "}
            <TranslationWrapper
              tDefault={"Bestand downloaden"}
              tKey={"tafels.modal.downloadQrCode.form.button.downloadFile"}
            />
          </Button>
        );
      }
    }
    // construct button_excelImport
    let button_excelImport = "";
    button_excelImport = (
      <SpecialButton
        busyFlag={this.state.excelImportBusy}
        buttonColor={"info"}
        buttonText={
          <TranslationWrapper
            tDefault={"Import (Jamezz Translation File)"}
            tKey={"transedit" + "." + "form.button.excelImport"}
          />
        }
        buttonTextDisabled={"Please Wait.."}
        disabled={true}
        onClick={() => this.excelImport()}
      />
    );

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Translations"} tKey={"transedit.form.pagetitle"} />} />
        {this.state.showTransedit == false ? (
          <div>
            <GridContainer>
              <VestigingenFilter />
            </GridContainer>

            <Card>
              <CardHeader color={"primary"} icon>
                <CardIcon color={"primary"}>
                  <Translate />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  <TranslationWrapper tDefault={"Edit Translations"} tKey={"transedit.table.cardEditTranslations"} />
                </h4>
              </CardHeader>

              <CardBody>
                <GridContainer>
                  {/* Left pane */}
                  <GridItem sm={10} xs={12}>
                    {/* ### STEP 1 of 3 : Choose language #############################################################*/}
                    <Card style={{ marginBottom: "40px", marginLeft: "80px" }}>
                      <CardHeader icon>
                        <CardIcon color={"info"}>
                          <Filter1 />
                        </CardIcon>
                        <FormLabel className={classes.labelHorizontal}>
                          <h6>
                            <strong>
                              <TranslationWrapper
                                tDefault={"Choose your translation Language"}
                                tKey={"transedit.form.label.translationLanguage"}
                              />
                            </strong>
                          </h6>
                        </FormLabel>
                      </CardHeader>
                      <CardBody>
                        <GridContainer>
                          {/* Custom Filter: Dropdown: transLang */}
                          <GridItem sm={8} xs={12}>
                            <FormControl className={classes.selectFormControl} fullWidth>
                              <Select
                                MenuProps={{
                                  className: classes.selectMenu,
                                }}
                                classes={{
                                  select: classes.select,
                                }}
                                inputProps={{
                                  name: "simpleSelect",
                                  id: "simple-select",
                                  style: { paddingTop: "32px" },
                                }}
                                onChange={(e) => {
                                  let transLang = e.target.value;
                                  this.setState({
                                    transLang: transLang,
                                  });
                                }}
                                value={this.state.transLang}
                              >
                                {showTransLangOptions}
                              </Select>
                            </FormControl>
                          </GridItem>
                        </GridContainer>
                      </CardBody>
                    </Card>
                    {/* ### STEP 2 of 3 : Choose categories #############################################################*/}
                    <Card style={{ marginBottom: "40px", marginLeft: "80px" }}>
                      <CardHeader icon>
                        <CardIcon color={"info"}>
                          <Filter2 />
                        </CardIcon>

                        <FormLabel className={classes.labelHorizontal}>
                          <h6>
                            <strong>
                              <TranslationWrapper
                                tDefault={"Choose the categories you want to edit"}
                                tKey={"transedit.form.label.translationCategories"}
                              />
                            </strong>
                          </h6>
                        </FormLabel>
                      </CardHeader>
                      <CardBody>
                        <GridContainer>
                          <GridItem sm={8} xs={12}>
                            <GridItem xs={12}>
                              <FormLabel className={classes.labelHorizontal}>
                                <Checkbox checked={this.isCheckedMenuItems()} onChange={this.handleCheckboxMenuItems} />
                                <TranslationWrapper
                                  tDefault={"Menu-Categories (Names and Descriptions)"}
                                  tKey={"transedit.form.label.toggle.MenuCategories"}
                                />
                              </FormLabel>
                            </GridItem>

                            <GridItem xs={12}>
                              <FormLabel className={classes.labelHorizontal}>
                                <Checkbox checked={this.isCheckedProducts()} onChange={this.handleCheckboxProducts} />
                                <TranslationWrapper
                                  tDefault={"Product Names"}
                                  tKey={"transedit.form.label.toggle.ProductNames"}
                                />
                              </FormLabel>
                            </GridItem>

                            <GridItem xs={12}>
                              <FormLabel className={classes.labelHorizontal}>
                                <Checkbox
                                  checked={this.isCheckedDescriptions()}
                                  onChange={this.handleCheckboxDescriptions}
                                />
                                <TranslationWrapper
                                  tDefault={"Product Descriptions"}
                                  tKey={"transedit.form.label.toggle.ProductDescriptions"}
                                />
                              </FormLabel>
                            </GridItem>

                            <GridItem xs={12}>
                              <FormLabel className={classes.labelHorizontal}>
                                <Checkbox
                                  checked={this.state.productUpsellSettings}
                                  onChange={this.handleProductCheckboxUpsellSettings}
                                />
                                <TranslationWrapper
                                  tDefault={"Product upsells"}
                                  tKey={"transedit.form.label.toggle.product_upsells"}
                                />
                              </FormLabel>
                            </GridItem>

                            <GridItem xs={12}>
                              <FormLabel className={classes.labelHorizontal}>
                                <Checkbox checked={this.isCheckedOptions()} onChange={this.handleCheckboxOptions} />
                                <TranslationWrapper tDefault={"Options"} tKey={"transedit.form.label.toggle.Options"} />
                              </FormLabel>
                            </GridItem>

                            <GridItem xs={12}>
                              <FormLabel className={classes.labelHorizontal}>
                                <Checkbox
                                  checked={this.state.upsellSettings}
                                  onChange={this.handleCheckboxUpsellSettings}
                                />
                                <TranslationWrapper
                                  tDefault={"Upsell settings"}
                                  tKey={"transedit.form.label.toggle.upsell_settings"}
                                />
                              </FormLabel>
                            </GridItem>
                          </GridItem>
                        </GridContainer>
                      </CardBody>
                    </Card>
                    {/* ### STEP 3 of 3 : Choose action #############################################################*/}
                    <Card style={{ marginBottom: "40px", marginLeft: "80px" }}>
                      <CardHeader icon>
                        <CardIcon color={"info"}>
                          <Filter3 />
                        </CardIcon>

                        <FormLabel className={classes.labelHorizontal}>
                          <h6>
                            <strong>
                              <TranslationWrapper
                                tDefault={"Choose your action"}
                                tKey={"transedit.form.label.translationChooseYourAction"}
                              />
                            </strong>
                          </h6>
                        </FormLabel>
                      </CardHeader>
                      <CardBody>
                        <GridItem sm={6} xs={12}>
                          <h4 className={classes.cardIconTitle}>
                            <TranslationWrapper
                              tDefault={"Start translation editor"}
                              tKey={"transedit.form.headerStartTranslationEditor"}
                            />
                          </h4>
                          <GridContainer>
                            <GridItem sm={8} xs={12}>
                              <SpecialButton
                                busyFlag={this.state.prepareTranseditBusy}
                                buttonColor={"warning"}
                                buttonText={
                                  <TranslationWrapper
                                    tDefault={"Collect translations and start Editor"}
                                    tKey={"transedit.form.button.startTransedit"}
                                  />
                                }
                                buttonTextDisabled={
                                  <TranslationWrapper
                                    tDefault={"Collecting Translations. Please Wait.."}
                                    tKey={"transedit.form.button.collectingTranslationsPleaseWait"}
                                  />
                                }
                                disabled={!this.props.filters.vestiging_id?.value || this.state.transLang == null}
                                onClick={() => this.startTransedit("")}
                              />
                            </GridItem>
                          </GridContainer>

                          <h4 className={classes.cardIconTitle}>
                            <TranslationWrapper
                              tDefault={"Export & Import"}
                              tKey={"transedit.form.headerImportExport"}
                            />
                          </h4>
                          <GridContainer>
                            <GridItem sm={12} xs={12}>
                              {button_excelExport}
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem md={8} xs={12}>
                              <form onSubmit={this.excelImport} ref={this.form}>
                                <GridContainer>
                                  <GridItem md={8} xs={12}>
                                    <SaveButton
                                      buttonText={getTranslation(
                                        "transedit.form.button.import",
                                        "Import (Jamezz-Language-File - excel format)"
                                      )}
                                      disabled={!this.state.hasUploadFilename || this.allowImportExport()}
                                      hasError={this.state.hasError}
                                      saving={this.state.importExcelBusy}
                                      type={"submit"}
                                    />
                                  </GridItem>
                                </GridContainer>
                                <GridContainer>
                                  <GridItem md={8} xs={12}>
                                    <input
                                      disabled={this.allowImportExport()}
                                      name={"bestand"}
                                      onChange={this.handleFileUploadChange}
                                      type={"file"}
                                    />
                                  </GridItem>
                                </GridContainer>
                              </form>
                            </GridItem>
                          </GridContainer>
                        </GridItem>
                      </CardBody>
                    </Card>
                    <GridContainer>
                      <GridItem sm={8} xs={12} />
                    </GridContainer>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>

            <GridContainer>
              <br />
            </GridContainer>
            <Card>
              <CardHeader color={"primary"} icon>
                <CardIcon color={"primary"}>
                  <Translate />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  <TranslationWrapper
                    tDefault={"Delete Translations"}
                    tKey={"transedit.table.cardDeleteTranslations"}
                  />
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem sm={3} xs={12}>
                    <FormLabel className={classes.labelHorizontal}>
                      <TranslationWrapper
                        tDefault={"Delete all translations of current salesarea"}
                        tKey={"transedit.form.label.deleteDescription"}
                      />
                    </FormLabel>
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12}>
                    <FormLabel className={classes.labelHorizontal}>
                      <Checkbox checked={this.isCheckedAllowDelete()} onChange={this.handleCheckboxAllowDelete} />
                      <TranslationWrapper
                        tDefault={"I want to delete all translations and I understand this is irreversible"}
                        tKey={"transedit.form.toggle.deleteAllTranslations"}
                      />
                    </FormLabel>
                  </GridItem>
                </GridContainer>
                {this.state.allowDeleteChecked == true ? (
                  <GridContainer>
                    <GridItem sm={9} xs={12}>
                      <SpecialButton
                        busyFlag={this.state.deleteAllBusy}
                        buttonColor={"danger"}
                        buttonText={
                          <TranslationWrapper
                            tDefault={"Delete ALL translations"}
                            tKey={"transedit.form.button.deleteAllTranslations"}
                          />
                        }
                        buttonTextDisabled={"Deleting ALL Translations. Please Wait.."}
                        onClick={() => this.deleteAllTranslations()}
                      />
                    </GridItem>
                  </GridContainer>
                ) : (
                  <div />
                )}
              </CardBody>
            </Card>
          </div>
        ) : (
          <div />
        )}
        {this.state.showTransedit ? (
          <div>
            <Button color={"success"} onClick={() => this.saveTransedit("")}>
              <TranslationWrapper tDefault={"Save"} tKey={"transedit.form.button.saveTransedit"} />
            </Button>
            <Button color={"danger"} onClick={() => this.cancelTransedit("")}>
              <TranslationWrapper tDefault={"Cancel"} tKey={"transedit.form.button.cancelTransedit"} />
            </Button>
            <GridContainer>
              <GridItem xs={12}>
                <JamezzTable
                  dataMapping={[
                    { dbfield: "id", editable: false },
                    { dbfield: "vestiging_id", editable: false },
                    { dbfield: "keytype", editable: false },
                    { dbfield: "keymatch", editable: false },
                    { dbfield: "keyname", editable: false },
                    { dbfield: "currentTranslation", editable: false },
                    { dbfield: "newTranslation", editable: true, inputtype: "Input" },
                  ]}
                  dbfields={
                    "id,vestiging_id,keytype,keymatch,keyname,currentTranslation,newTranslation,transLang,sessionGarble"
                  }
                  fetchUrl={"core/transedit"}
                  filters={this.props.filters}
                  headerIcon={<Translate />}
                  headers={[
                    {
                      label: getTranslation("transedit.table.id", "#"),
                      sortable: true,
                      sortKey: "id",
                    },
                    {
                      label: getTranslation("transedit.table.vestiging_id", "#"),
                      sortable: true,
                      sortKey: "vestiging_id",
                    },
                    {
                      label: getTranslation("transedit.table.keytype", "keytype"),
                      sortable: true,
                      sortKey: "keytype",
                    },
                    {
                      label: getTranslation("transedit.table.keymatch", "keymatch"),
                      sortable: true,
                      sortKey: "keymatch",
                    },
                    {
                      label: getTranslation("transedit.table.keyname", "keyname"),
                      sortable: true,
                      sortKey: "keyname",
                    },
                    {
                      label:
                        getTranslation("transedit.table.currentTranslation", "translation") +
                        " " +
                        this.state.transLang.toUpperCase(),
                      sortable: true,
                      sortKey: "currentTranslation",
                    },
                    {
                      label: getTranslation("transedit.table.newTranslation", "new translation"),
                      sortable: false,
                    },
                  ]}
                  reduxKey={"Transedit"}
                  ref={this.jamezzTable}
                  showAutoRenew
                  tableTitle={<TranslationWrapper tDefault={"Translations"} tKey={"transedit.table.titel"} />}
                />
              </GridItem>
            </GridContainer>
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

//##############################################################################
//REDUX
const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  if (state.filtersV2.sessionGarble) {
    filters.sessionGarble = state.filtersV2.sessionGarble;
  }
  return {
    filters,
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

//##############################################################################
const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (key, filter) => {
      dispatch({
        type: actions.SET_FILTER,
        payload: { key, filter },
      });
    },
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

//##############################################################################
//export
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Index, tafelStyle));
